const urls = {
  educationContents: '/education-contents',
  contentBank: '/content-banks',
  profile: '/profile',
  categories: '/categories',
  bookmarks: '/user-saved-contents',
  spentTime: '/user-stats',
  userActionLogs: '/user-action-logs',
  tags: '/tags',
};

export default urls;
